"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerPopUp = exports.ContainerFixed = exports.ContainerBtnPopUpChat = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject, _templateObject2, _templateObject3;

// Container para chat fixed
var ContainerFixed = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: auto;\n  max-width: 550px;\n  min-width: 325px;\n  height: 100%;\n  flex-grow: 2;\n  background-color: white;\n  border: 1px solid #f0f0f0;\n  z-index: 1000;\n  padding: 0px;\n  @media (max-width: 1024px) {\n    width: auto;\n    max-width: 100%;\n  }\n  @media (max-width: 600px) {\n    width: 90%;\n    min-width: 300px;\n  }\n"])));

exports.ContainerFixed = ContainerFixed;

var ContainerBtnPopUpChat = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  border-radius: 50%;\n  height: 34px;\n  width: 34px;\n\n  .container-btn-popUpChat {\n    height: inherit;\n    width: inherit;\n    overflow: hidden;\n  }\n"])));

exports.ContainerBtnPopUpChat = ContainerBtnPopUpChat;

var ContainerPopUp = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  top: 20px;\n  right: 23px;\n  bottom: 20px;\n  box-shadow: 0px 2px 10px 0px #00000073;\n  z-index: 1000;\n  width: calc(100% - 50px);\n  max-width: 550px;\n  min-width: 325px;\n  border-radius: 10px;\n  background: white;\n  padding: 0px;\n"])));

exports.ContainerPopUp = ContainerPopUp;